export default {

  // The install method will be called with the Vue constructor as the first argument, along with possible options
  install (Vue) {
    Vue.prototype.showNotification = (response, type = 'info', duration = 3000) => {
      if (response !== null && response !== undefined) {
        let message = ''
        switch (type) {
          case 'success':
            if (response.data !== null && response.data !== undefined) {
              if (response.data.message !== null && response.data.message !== undefined) {
                message += response.data.message + '<br>'
              }
            } else {
              message += response
            }
            break
          case 'error':
            if (response.data !== null && response.data !== undefined) {
              if (response.data.message !== null && response.data.message !== undefined) {
                message += response.data.message + '<br>'
              }
              if (response.data.errors !== null && response.data.errors !== undefined) {
                let errors = Object.values(response.data.errors)
                if (Array.isArray(errors)) {
                  if (errors.length > 0) {
                    errors.forEach(element => {
                      if (Array.isArray(element)) {
                        if (element.length > 0) {
                          element.forEach(value => {
                            message += value + '<br>'
                          })
                        }
                      }
                    })
                  }
                } else {
                  message += response.data.errors + '<br>'
                }
              }
            } else if ((response.message !== null && response.message !== undefined) || (response.errors !== null && response.errors !== undefined)) {
              if (response.message !== null && response.message !== undefined) {
                message += response.message + '<br>'
              }
              if (response.errors !== null && response.errors !== undefined) {
                let errors = Object.values(response.errors)
                if (Array.isArray(errors)) {
                  if (errors.length > 0) {
                    errors.forEach(element => {
                      if (Array.isArray(element)) {
                        if (element.length > 0) {
                          element.forEach(value => {
                            message += value + '<br>'
                          })
                        }
                      }
                    })
                  }
                } else {
                  message += response.errors + '<br>'
                }
              }
            } else {
              message += response
            }
            break
          default:
            if (response.data !== null && response.data !== undefined) {
              if (response.data.message !== null && response.data.message !== undefined) {
                message += response.data.message + '<br>'
              }
            } else {
              message += response + '<br>'
            }
            break
        }
        if (message !== '') {
          Vue.prototype.$notify({
            group: 'gst',
            text: message,
            type: type,
            duration: duration
          })
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/notifications.js